import React from 'react'

import { Form, Radio, Select } from 'antd'

import SwitcherPreview from '../components/switcher-preview'

const FormItem = Form.Item
const RadioGroup = Radio.Group;
const Option = Select.Option

class ButtonSelection extends React.Component {
    static defaultProps = {}
    state = {
        buttonType: "dropdown",
        buttonPosition : "bl",
        addFlags : true
    }

    onButtonTypeChange = (e) => {
        this.setState({
            value: e.target.value,
        });
    }

    render() {

        const { apiKey, form, buttonType, buttonPosition, addFlags, cdnHost } = this.props

        const selectedButtonType = form.getFieldValue("buttonType");
        const selectedAddFlags = form.getFieldValue("addFlags") == "true" ? true : false;
        const selectedSourceLanguage = form.getFieldValue("sourceLanguage");

        let selectedTargetLanguages = form.getFieldValue("targetLanguages") || [];
        selectedTargetLanguages = selectedTargetLanguages.map(lang => lang.key)

        const radioStyle = {
          display: 'block',
          height: '30px',
          lineHeight: '30px',
        };

        const buttonPositionHtml = [
            {label : "Top Left", value: "tl"},
            {label : "Top Right", value: "tr"},
            {label : "Bottom Left", value: "bl"},
            {label : "Bottom Right", value: "br"},
            //{label : "Menu", value: "menu"},
            //{label : "Custom", value: "custom"}
        ].map((pos, index) => {
            return (
              <Option key={index} value={pos.value}>
                {pos.label}
              </Option>
            )
        })

        const positionHelper = (
          <div className='positionhelper'>
            <p>Position on the screen where the default switcher will be displayed</p>

            <p>You can add the HTML code <b>&#x3C;div id=&#x22;teral-switcher-here&#x22;&#x3E;&#x3C;/div&#x3E;</b> wherever you want in the HTML code and the button will appear there.</p>

            <p>You can use the <b>Teral Language Switcher</b> widget to customise the position of the switcher. <a target='_blank' href="/wp-admin/widgets.php">Widgets</a></p>

            <p>You can also use the shortcode <b>[tl-switcher]</b> widget to customise the position of the switcher.</p>
          </div>
        )
        return (
            <div>
                <div>
                  <FormItem label="Style">
                    {form.getFieldDecorator('buttonType', {
                        initialValue : buttonType,
                        rules: [{ required: true, message: 'Button Type is required' }],
                    })(
                        <RadioGroup onChange={this.onButtonTypeChange} value={this.state.buttonType}>
                            <Radio style={radioStyle} value="list">List</Radio>
                            <Radio style={radioStyle} value="dropdown">Dropdown</Radio>
                       </RadioGroup>
                    )}
                  </FormItem>

                  <FormItem label="Add flags">
                    {form.getFieldDecorator('addFlags', {
                        initialValue : addFlags || String(this.state.addFlags),
                    })(
                        <RadioGroup onChange={this.onButtonTypeChange} value={this.state.buttonType}>
                            <Radio style={radioStyle} value="true">Yes</Radio>
                            <Radio style={radioStyle} value="false">No</Radio>
                       </RadioGroup>
                    )}
                  </FormItem>

                  <FormItem label="Preview">
                    <div>
                        <SwitcherPreview
                            apiKey={apiKey}
                            cdnHost={cdnHost}
                            sourceLanguage={selectedSourceLanguage}
                            targetLanguages={selectedTargetLanguages}
                            buttonType={selectedButtonType}
                            addFlags={selectedAddFlags}
                        />
                    </div>
                  </FormItem>

                   <FormItem label="Position" help={positionHelper}>
                     {form.getFieldDecorator('buttonPosition', {
                         initialValue : buttonPosition,
                         rules: [
                             { required: true, message: 'Button position is required' },
                         ],
                     })(
                       <Select
                         style={{ width: '100%' }}
                       >
                         {buttonPositionHtml}
                       </Select>
                     )}
                   </FormItem>

                </div>

            </div>
        )
    }
}

export default ButtonSelection
